import { $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $setSelection } from 'lexical';
import { useEffect } from 'react';
import { initialPrefillTag } from '../utils';

export interface PrefillPluginProps {
    initialHtml: string;
}

const PrefillPlugin = ({ initialHtml }: PrefillPluginProps) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const parser = new DOMParser();
        editor.update(
            () => {
                const dom = parser.parseFromString(initialHtml, 'text/html');
                const nodes = $generateNodesFromDOM(editor, dom);
                $getRoot()
                    .clear()
                    .append(...nodes);
                $setSelection(null); // this will select nothing, therefore preventing "autofocus" when initialHtml is changed
            },
            { tag: initialPrefillTag },
        );
    }, [editor, initialHtml]);

    return null;
};

export default PrefillPlugin;
